var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 1.1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18.217c0 .433-.35.783-.782.783H2.283a.783.783 0 0 1-.783-.783V4.846c0-.208.083-.407.23-.554L4.791 1.23A.782.782 0 0 1 5.346 1h13.372c.432 0 .782.35.782.783v16.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63 10.391h11.74c.432 0 .782.35.782.783V19H3.848v-7.826c0-.432.35-.783.782-.783zM5.413 1h10.174v4.696c0 .432-.35.782-.783.782H6.196a.783.783 0 0 1-.783-.782V1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.457 2.565h1.565v2.348h-1.565zM6.196 12.739h5.087M6.196 15.087h8.608"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.059c4cf8.svg";
export { ForwardRef as ReactComponent };